'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function VNFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-qqd8t23eg", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-1akwgr4jq", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-c2rrng98f" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-c2rrng98f", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-qqd8t23eg)" }, /* @__PURE__ */ React.createElement("path", { fill: "#f7fcff", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("use", { fill: "#e31d1c", xlinkHref: "#mantine-c2rrng98f" }), /* @__PURE__ */ React.createElement("g", { fill: "#ffd221", mask: "url(#mantine-1akwgr4jq)" }, /* @__PURE__ */ React.createElement("path", { d: "M16.062 15.98l-5.151 3.275 1.728-5.733-3.674-3.746 5.065-.11 2.24-5.66 2.043 5.734 5.053.089-3.797 3.814 1.773 5.454z" }))))
  );
}

export { VNFlag };
//# sourceMappingURL=VN.mjs.map
